/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Vittorio's Portfolio",
  description:
    "An enthusiastic postgraduate student equipped with a blend of creativity, theoretical insight, and practical skills to tackle today's AI challenges.",
  og: {
    title: "Vittorio Pellegrini's Portfolio",
    type: "website",
    url: "http://vittoriop17.github.io",
  },
};

//Home Page
const greeting = {
  title: "Vittorio Pellegrini",
  logo_name: "Vittorio",
  nickname: "",
  subTitle:
    "An enthusiastic postgraduate student equipped with a blend of creativity, theoretical insight, and practical skills to tackle today's AI challenges.",
  resumeLink:
    "https://drive.google.com/file/d/1e2IvJv1I8sW1EGaw8Lzd5jfuRE38sOA4/view?usp=sharing",
  portfolio_repository: "https://github.com/vittoriop17/masterPortfolio",
  githubProfile: "https://github.com/vittoriop17",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/vittoriop17",
  // linkedin: "https://www.linkedin.com/in/vittorio--pellegrini/",
  // gmail: "vittoriop.17@gmail.com",
  // gitlab: "https://gitlab.com/Vittorio98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/Vittorio_1919",
  // instagram: "https://www.instagram.com/pellittorio/"

  {
    name: "Github",
    link: "https://github.com/vittoriop17",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/vittorio--pellegrini/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:vittoriop.17@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Machine Learning & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Worked on several projects involving machine learning.",
        "⚡ Experience of working with PyTorch, Tensorflow, Keras.",
        "⚡ Applications: audio, video, time-series, text.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Natural Language Processing",
      fileName: "FullStackImg",
      skills: [
        "⚡ Collaborating with a Swedish company specialised in the field of NLP. ",
        "⚡ Developing a pipeline for the extraction of useful insights from large collection of user feedback. ",
        "⚡ Developing university projects in the field of NLP (travel chatbot, text summarizer, ...)",
      ],
      softwareSkills: [
        {
          skillName: "NLP",
          fontAwesomeClassname: "carbon:ibm-watson-natural-language-understanding",
          style: {
            color: "#E34F26",
          },
        }
      ],
    },
    {
      title: "Java",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Over 7 years of academic and work experience with Java language. ",
        "⚡ Developing automated tests for browser, iOS, and Android applications. ",
      ],
      softwareSkills: [
        {
          skillName: "JAVA",
          fontAwesomeClassname: "devicon:java",
          style: {
            color: "#E34F26",
          },
        }
      ],
    },
    {
      title: "Python",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Over 3 years of university experience with Python. ",
        "⚡ Knowledge and experience with common Python libraries (pandas, matplotlib, numpy, scipy, scikit-learn, ...). ",
      ],
      softwareSkills: [
        {
          skillName: "PANDAS",
          fontAwesomeClassname: "devicon:pandas-wordmark",
          style: {
            color: "#E34F26",
          }},
          {
          skillName: "MATPLOTLIB",
          fontAwesomeClassname: "logos:matplotlib-icon",
          style: {
            color: "#E34F26",
          }},
          {
          skillName: "SCIPY",
          fontAwesomeClassname: "simple-icons:scipy",
          style: {
            color: "#E34F26",
          }},
          {
          skillName: "SCIKIT-LEARN",
          fontAwesomeClassname: "devicon:scikitlearn",
          style: {
            color: "#E34F26",
          }},
          {
          skillName: "NUMPY",
          fontAwesomeClassname: "vscode-icons:file-type-numpy",
          style: {
            color: "#E34F26",
          }
        }
      ],
    }
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/pellittorio/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/pellittorio",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/Vittorio_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/pellittorio",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@Vittorio391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Kungliga Tekniska Hogskolan (Stockholm)",
      subtitle: "M.S. in Machine Learning",
      logo_path: "kth_logo.svg",
      alt_name: "Kungliga Tekniska Hogskolan",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ Interdisciplinary Expertise: I have applied machine learning techniques across various domains. From Music Informatics to Medical Image Analysis. This interdisciplinary approach gave me the ability to understand how AI can be leveraged in different contexts.",
        "⚡ Practical Proficiency: I have solved several practical problems with hands-on projects in AI and data science, including conversational systems, information retrieval, and medical image analysis. These projects demonstrate my ability to translate theoretical knowledge into real-world applications.",
        "⚡ Communication and Collaboration: I worked in many group projects. This improved my communication and teamwork skills.",
        "⚡ Teaching skills: I have also done teaching assistant activities in the course Search Engines and Information Retrieval Systems.",
      ],
      website_link:
        "https://drive.google.com/file/d/1ouRaTAp2frGCLkLVLTWDCjLXME_RFwBf/view?usp=sharing", //it's actually the link to the ToR
    },
    {
      title: "Polytechnic of Turin",
      subtitle: "M.S. in Data Science and Engineering",
      logo_path: "polito_logo.svg",
      alt_name: "Polytechnic of Turin",
      duration: "2020 - 2023",
      descriptions: [
        "⚡ Theoretical Depth: I followed many theoretical courses: computational linear algebra, mathematics in machine learning, etc. These provided a strong theoretical foundation in AI, giving a deeper understanding of the algorithms and models in the field of AI",
        "⚡ Practical Proficiency: Complementing the theoretical courses, I have also engaged in practical courses such as data management, distributed architectures, etc. These hands-on experiences gave me the necessary skills to work with big data, and neural networks.",
        "⚡ Ethical Awareness: the inclusion of data ethics and data protection in my curriculum highlights my commitment to ethical considerations in AI and data science.",
      ],
      website_link:
        "https://drive.google.com/file/d/13yVAeRH22sLfDaSGmGSYAzhb217hQLJC/view?usp=sharing",
    },
    {
      title: "Polytechnic of Turin",
      subtitle: "Bachelor in Computer Engineering",
      logo_path: "polito_logo.svg",
      alt_name: "Polytechnic of Turin",
      duration: "2016 - 2019",
      descriptions: [
        "⚡ Computer Science basics: I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, etc.",
        "⚡ Fundamental of Electronics: the university provided many courses oriented towards the understanding of the hardware.",
      ],
      website_link:
        "https://drive.google.com/file/d/1F5TnCSTNcPk42PWhKUHGzO8TO819IuLZ/view?usp=sharing",
    },
  ],
};

const certifications = {
  certifications: [],
  //  certifications: [
  //    {
  //      title: "Machine Learning",
  //      subtitle: "- Andrew Ng",
  //      logo_path: "stanford_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
  //      alt_name: "Stanford University",
  //      color_code: "#8C151599",
  //    },
  //    {
  //      title: "Deep Learning",
  //      subtitle: "- Andrew Ng",
  //      logo_path: "deeplearning_ai_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
  //      alt_name: "deeplearning.ai",
  //      color_code: "#00000099",
  //    },
  //    {
  //      title: "ML on GCP",
  //      subtitle: "- GCP Training",
  //      logo_path: "google_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
  //      alt_name: "Google",
  //      color_code: "#0C9D5899",
  //    },
  //    {
  //      title: "Data Science",
  //      subtitle: "- Alex Aklson",
  //      logo_path: "ibm_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
  //      alt_name: "IBM",
  //      color_code: "#1F70C199",
  //    },
  //    {
  //      title: "Big Data",
  //      subtitle: "- Kim Akers",
  //      logo_path: "microsoft_logo.png",
  //      certificate_link:
  //        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
  //      alt_name: "Microsoft",
  //      color_code: "#D83B0199",
  //    },
  //    {
  //      title: "Advanced Data Science",
  //      subtitle: "- Romeo Kienzler",
  //      logo_path: "ibm_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
  //      alt_name: "IBM",
  //      color_code: "#1F70C199",
  //    },
  //    {
  //      title: "Advanced ML on GCP",
  //      subtitle: "- GCP Training",
  //      logo_path: "google_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
  //      alt_name: "Google",
  //      color_code: "#0C9D5899",
  //    },
  //    {
  //      title: "DL on Tensorflow",
  //      subtitle: "- Laurence Moroney",
  //      logo_path: "deeplearning_ai_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
  //      alt_name: "deeplearning.ai",
  //      color_code: "#00000099",
  //    },
  //    {
  //      title: "Fullstack Development",
  //      subtitle: "- Jogesh Muppala",
  //      logo_path: "coursera_logo.png",
  //      certificate_link:
  //        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
  //      alt_name: "Coursera",
  //      color_code: "#2A73CC",
  //    },
  //    {
  //      title: "Kuberenetes on GCP",
  //      subtitle: "- Qwiklabs",
  //      logo_path: "gcp_logo.png",
  //      certificate_link:
  //        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
  //      alt_name: "GCP",
  //      color_code: "#4285F499",
  //    },
  //    {
  //      title: "Cryptography",
  //      subtitle: "- Saurabh Mukhopadhyay",
  //      logo_path: "nptel_logo.png",
  //      certificate_link:
  //        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
  //      alt_name: "NPTEL",
  //      color_code: "#FFBB0099",
  //    },
  //    {
  //      title: "Cloud Architecture",
  //      subtitle: "- Qwiklabs",
  //      logo_path: "gcp_logo.png",
  //      certificate_link:
  //        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
  //      alt_name: "GCP",
  //      color_code: "#4285F499",
  //    },
  //  ],
};

// Experience Page
const experience = {
  title: "Work Experience",
  subtitle: "",
  description:
    "I have previous experience in Automatic Testing, where my responsibilities included implementing tests for Android, iOS, and web applications. Although this role differs from my current career path, it was a significant milestone in my professional journey. It marked my initial and singular venture into the realm of computer science, and it was during this time that I acquired fundamental skills in teamwork and embraced AGILE development principles.",
  header_image_path: "experience.svg",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Teaching Assistant",
      work: true,
      experiences: [
        {
          title: "Search Engine and Information Retrieval Systems",
          company: "Royal Institute of Technology, Stockholm",
          company_url:
            "https://www.kth.se/",
          logo_path: "kth_logo.svg",
          duration: "Jan 2022 - Jun 2023",
          location: "Stockholm, Sweden",
          description:
            "I assisted in instructing and mentoring students in the \"Search Engine and Information Retrieval System\" course.\n I graded students' assignments ensuring fair and consistent evaluation.\n",
          color: "#9b1578",
        },
      ],
    },{
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Extraction of useful insights from large collections of user feedback.",
          company: "Gavagai",
          company_url: "https://www.gavagai.io/",
          logo_path: "gavagai_logo.webp",
          duration: "Nov 2022 - Jun 2023",
          location: "Stockholm, Sweden",
          description: "I developed a pipeline for the extraction of useful insights from large collections of user feedback. The objective was reached fine-tuning a sentence-BERT model with self-supervision along with HDBSCAN for clustering similar sentences.",
          color: "#9b1578"
        },
        {
          title: "Automatic Test Developer",
          company: "Reply SPA",
          company_url:
            "https://www.linkedin.com/company/reply/?originalSubdomain=en",
          logo_path: "reply.jpg",
          duration: "Nov 2019 - Jun 2020",
          location: "Turin, Italy",
          description:
            "I designed automatic tests in Java, with the usage of Appium and Selenium frameworks. In particular, I created automated tests for web, Android, and iOS apps, utilizing Appium for mobile and Selenium for web testing. ",
          color: "#9b1578",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I have leveraged a wide array of cutting-edge technology tools in my projects, applying theoretical expertise across various AI domains to address challenges spanning NLP, music analysis, computer vision, and point cloud processing.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    //    {
    //      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
    //      name: "Artificial Intelligence Paper",
    //      createdAt: "2020-03-06T16:26:54Z",
    //      description: "Paper Written on Artificial Intelligence published in xyz ",
    //      url:
    //        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //    },
    //    {
    //      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //      name: "Artificial Intelligence Paper",
    //      createdAt: "2020-03-06T16:26:54Z",
    //      description: "Paper Written on Artificial Intelligence published in xyz ",
    //      url:
    //        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //    },
    //    {
    //      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //      name: "Artificial Intelligence Paper",
    //      createdAt: "2020-03-06T16:26:54Z",
    //      description: "Paper Written on Artificial Intelligence published in xyz ",
    //      url:
    //        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //    },
    //    {
    //      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
    //      name: "Artificial Intelligence Paper",
    //      createdAt: "2020-03-06T16:26:54Z",
    //      description: "Paper Written on Artificial Intelligence published in xyz ",
    //      url:
    //        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //    },
    //    {
    //      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
    //      name: "Artificial Intelligence Paper",
    //      createdAt: "2020-03-06T16:26:54Z",
    //      description: "Paper Written on Artificial Intelligence published in xyz ",
    //      url:
    //        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    //    },
  ],
};

const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "io.jpg",
    description:
      "You can message me on LinkedIn, or send me an email. I will reply within 24 hours. I am open to start working as soon as possible in the fields of Data Science and Machine Learning",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
    locality: "Kanodar",
    country: "IN",
    region: "Gujarat",
    postalCode: "385520",
    streetAddress: "Ambavadi vas",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

// Contact Page
//const contactPageData = {
//  contactSection: {
//    title: "Contact Me",
//    // profile_image_path: "animated_Vittorio.png",
//    description:
//      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, and Data Science.",
//  },
//  blogSection: {/*
//    title: "Blogs",
//    subtitle:
//      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
//    link: "https://blogs.ashutoshhathidara.com/",
//    avatar_image_path: "blogs_image.svg",*/
//  },
//  addressSection: {
//    /*title: "Address",
//    subtitle:
//      "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
//    locality: "Kanodar",
//    country: "IN",
//    region: "Gujarat",
//    postalCode: "385520",
//    streetAddress: "Ambavadi vas",
//    avatar_image_path: "address_image.svg",
//    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",*/
//  },
//  phoneSection: {
//    title: "",
//    subtitle: "",
//  },
//};
//

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
